import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-flight',
  templateUrl: './no-flight.component.html',
  styleUrls: ['./no-flight.component.scss']
})
export class NoFlightComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
